import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import { Rating } from '@material-ui/lab';
import RatingStarIcon from 'assets/icons/svg/RatingStarIcon';

const useStyles = makeStyles({
  stars: { display: 'flex', alignItems: 'center', gap: 8 },
  dim: { '& .MuiRating-iconFilled': { color: '#f3d9a8' } },
  effective: { fontSize: 16, fontWeight: 700, color: '#8a5000' },
  yesNo: { display: 'flex', gap: 8 },
  yes: { backgroundColor: green[600], color: '#fff', '&:hover': { backgroundColor: green[700] } },
  no: { backgroundColor: red[600], color: '#fff', '&:hover': { backgroundColor: red[700] } },
});

interface IStarsProps {
  name: string;
  value: number | null;
  size: 'small' | 'large';
  dim?: boolean;
  label?: string | null;
  onChange(value: number): void;
}

export const StarsValue = ({ name, value, size, dim, label, onChange }: IStarsProps) => {
  const classes = useStyles();

  return (
    <span className={classes.stars}>
      <Rating
        name={name}
        value={value}
        size={size}
        icon={<RatingStarIcon fontSize="inherit" />}
        className={dim ? classes.dim : undefined}
        onChange={(_, next) => {
          // MUI отдаёт null при клике по уже выбранной звезде — трактуем как выбор показанного значения
          const picked = next ?? value;
          if (picked !== null) onChange(picked);
        }}
      />
      {label && <span className={classes.effective}>{label}</span>}
    </span>
  );
};

interface IYesNoProps {
  value: boolean | null;
  size: 'small' | 'medium';
  onChange(value: boolean): void;
}

export const YesNoValue = ({ value, size, onChange }: IYesNoProps) => {
  const classes = useStyles();

  return (
    <span className={classes.yesNo}>
      <Button
        size={size}
        variant={value === true ? 'contained' : 'outlined'}
        className={value === true ? classes.yes : undefined}
        onClick={() => onChange(true)}
      >
        Да
      </Button>
      <Button
        size={size}
        variant={value === false ? 'contained' : 'outlined'}
        className={value === false ? classes.no : undefined}
        onClick={() => onChange(false)}
      >
        Нет
      </Button>
    </span>
  );
};
